import {
  GenerateSearchieResponseProto,
  SearchSessionsResponse,
} from '@fullstory/proto/fs/services/alexa';

export enum SessionReplayTypes {
  UsersAppCacheIsLoading = 'sessionReplay.users.APP_CACHE_IS_LOADING',
  UsersAppCacheLoadFailed = 'sessionReplay.users.APP_CACHE_LOAD_FAILED',
  UsersAppCacheRefetching = 'sessionReplay.users.APP_CACHE_IS_REFETCHING',
  UsersAppCacheHasData = 'sessionReplay.users.APP_CACHE_HAS_DATA',
  UsersAppCacheFresh = 'sessionReplay.users.APP_CACHE_FRESH',
  UsersAppCacheSwap = 'sessionReplay.users.APP_CACHE_SWAP',
  UsersAppCacheClear = 'sessionReplay.users.APP_CACHE_CLEAR',
}

export type UsersAndSessions = {
  users: GenerateSearchieResponseProto;
  sessions: { [id: string]: SearchSessionsResponse };
};

export enum SessionPlaylistCardFilterActionTypes {
  SetFunnelStep = 'SetFunnelStep',
  SetFunnelConverted = 'SetFunnelConverted',
  SetActiveSegmentId = 'SetActiveSegmentId',
  SetDimension = 'SetDimension',
  SetPage = 'SetPage',
  SetCompleteSessions = 'SetCompleteSessions',
  SetEventIndex = 'SetEventIndex',
  SetReturnEventIndex = 'SetReturnEventIndex',
  SetCohortIndex = 'SetCohortIndex',
  SetReturnWindowIndex = 'SetReturnWindowIndex',
  ClearFilters = 'ClearFilters',
}

export interface SessionPlaylistCardFilterState {
  [storageId: string]: FilterState;
}

export interface FilterState {
  funnelStep: number;
  funnelConverted: string | null;
  activeSegmentId: string | null;
  dimension: string | null;
  page: number;
  // Used if query size is different than page size. E.g., If page = 5 but query size = 10, then we use this to determine
  // when we actually need to query for more data vs what page number to actually show.
  queryPage: number;
  completeSessions: boolean;
  eventIndex: number;
  returnEventIndex: number;
  cohortIndex: number;
  returnWindowIndex: number;
}

export const defaultSessionPlaylistCardFilterState: SessionPlaylistCardFilterState = {};
